import { cloneDeep } from 'lodash';
import { HostInfoRow } from 'mbs-ui-shared@components/computers-shared/get-general-host-Info';
import { AvailablePlanTypes } from 'mbs-ui-shared@models/backup/available-plan-types';
import { PlanInfo } from 'mbs-ui-shared@models/backup/plan-info-model';
import { StorageAccountV1 } from 'mbs-ui-shared@models/StorageAccount';

export interface ComputerBackupData<T> {
  data: T;
  loading: boolean;
  visibleLoading: boolean;
  loaded: boolean;
  obsolescenceMark: number;
  error?: Error;
}

export interface DestinationBackupData<T> extends ComputerBackupData<T> {
  doNotIncludeLocal: boolean;
}

export interface PlanStatusData {
  saving: boolean;
  running: boolean;
}

export type PlansStatuses = {
  [id: string]: PlanStatusData;
};

export interface ComputerDetails {
  id: string;
  hostInfo?: ComputerBackupData<HostInfoRow[]>;
  destinations?: DestinationBackupData<StorageAccountV1[]>;
  plans?: ComputerBackupData<PlanInfo[]>;
  availablePlans?: ComputerBackupData<AvailablePlanTypes>;
  timeZoneOffset?: number;
  syncProcess: boolean;
}

export interface ComputersBackupState {
  plansStatuses: PlansStatuses;
}

export const initialComputerBackupData: ComputerBackupData<any> = {
  data: [],
  loading: false,
  visibleLoading: false,
  loaded: false,
  obsolescenceMark: null
};

export const initialDestinationBackupData: DestinationBackupData<any> = {
  ...initialComputerBackupData,
  doNotIncludeLocal: false
};

export const initialComputerDetails: ComputerDetails = {
  id: '',
  hostInfo: cloneDeep(initialComputerBackupData),
  destinations: cloneDeep(initialDestinationBackupData),
  plans: cloneDeep(initialComputerBackupData),
  availablePlans: cloneDeep(initialComputerBackupData),
  timeZoneOffset: 0,
  syncProcess: false
};

export const initialComputersBackupState: ComputersBackupState = {
  plansStatuses: {}
};
